import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { history } from "../../helpers";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import { connect } from "react-redux";
import * as QueryString from "query-string";
import { userActions } from "../../actions";
import { bcryptjs } from "bcryptjs";

function LoginPage(props) {
  const { login, logout, location, authentication } = props;

  const [state, setState] = useState({
    email: "",
    password: "",
    submitted: false,
  });
  const { email, password, submitted } = state;

  var bcrypt = require("bcryptjs");
  var salt = bcrypt.genSaltSync(10);

  const params = QueryString.parse(location?.search);
  const code = params.pwrc;

  if (code !== undefined) {
    history.push("/pwdreset?c=" + code);
  }

  useEffect(() => {
    // TODO: this triggers a warning about modifying state the wrong way (issue #34)
    logout();
    history.replace("/");
  }, []);

  function handleChange(e) {
    const { name, value } = e.target;
    setState({ ...state, [name]: value });
  }

  function handleSubmit(e) {
    e.preventDefault();

    setState({ ...state, submitted: true });
    const { email, password } = state;
    if (email && password) {
      login(email, password);
    }
  }

  return (
    <>
      {authentication?.user?.user_id &&
        params.status !== "token_expired" &&
        history.push("/org/" + authentication.user.org_id + "/dealjackets")}
      {!authentication?.user?.user_id && (
        <div className="login">
          {params.status === "token_expired" && !authentication.loggingIn && (
            <>
              <span className="errormessage">
                Your login token has expired. Please login again.
              </span>
              <br /> <br />
            </>
          )}
          {params.status === "invalid_ip" && !authentication.loggingIn && (
            <>
              <div className="pwdMessage">
                <span className="loginError">
                  We're unable to log you in with those credentials.
                  <br />
                  <br />
                  <hr />
                  <br />
                  Some hints:
                  <br />
                  <br />
                  <ul>
                    <li>double-check your username and password</li>
                    <li>
                      verify that you're allowed to connect from this location
                    </li>
                    <li>email us at help@gotagtech.com</li>
                  </ul>
                </span>
              </div>
              <br /> <br />
            </>
          )}
          {params.status === "pwd_reset_requested" &&
            !authentication.loggingIn && (
              <>
                <span className="pwdMessage">
                  Reset requested. If there is an account associated with that
                  email address, you will receive an email with instructions for
                  changing your password.
                </span>
                <br /> <br />
              </>
            )}
          {params.status === "pwd_reset_submitted" &&
            !authentication.loggingIn && (
              <>
                <span className="pwdMessage">
                  Your password has been reset! Log in to continue.
                </span>
                <br /> <br />
              </>
            )}
          <TextField name="email" label="email" onChange={handleChange} />
          <br />
          {submitted && !email && (
            <div classname="inputError">email is required.</div>
          )}

          <TextField
            name="password"
            label="password"
            type="password"
            onChange={handleChange}
          />
          <br />
          {submitted && !email && (
            <div classname="inputError">password is required.</div>
          )}
          <br />

          <Button variant="outlined" color="primary" onClick={handleSubmit}>
            Log In
          </Button>
          <br />
          <br />
          <span className="forgotPasswordLink">
            <Link to="pwd_change">forgot password?</Link>
          </span>
        </div>
      )}
    </>
  );
}

function mapStateToProps(state) {
  const { authentication } = state;
  return {
    authentication,
  };
}

const actionCreators = {
  login: userActions.login,
  logout: userActions.logout,
};

const connectedLoginPage = connect(mapStateToProps, actionCreators)(LoginPage);
export { connectedLoginPage as LoginPage };
